// generated by srcset-codegen
import src from "./clocked-out.svg";

const width = 24;
const height = 24;
export default { src, width, height };
